<template>
  <div>
    <equipment-edit v-model="still" title="Still" :sites="sites"
                    @save="save" :loading="loading" :saving="saving" :dirty.sync="dirty"/>
    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import {format} from 'date-fns'
import EquipmentEdit from '@/views/equipment/EquipmentEdit'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'EquipmentStillsEdit',
  mixins: [confirmLeave],
  components: {EquipmentEdit},
  props: {
    stillId: {type:String, required:false}
  },
  data () {
    return {
      still: {name:'',active:true,siteId:'',manufacturer:'',modelNumber:'',serialNumber:'',
              maintenance:{frequency:0,frequencyUnits:'never',nextDate:format(new Date(), 'yyyy-MM-dd'),description:''}},
      dirty: false,
      saving: false,
      loading: false
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(!this.stillId, {B266:true});
    }
  },
  async created() {
    this.loading = true;
    if (this.stillId) {
      const results = await this.$apiCall(`query EquipmentStillsEdit($id:ID!) {
                                                still(id:$id) {
                                                  id,name,active,site{id},pictureURL,
                                                  manufacturer,modelNumber,serialNumber,
                                                  maintenance {frequency,frequencyUnits,nextDate,description}
                                                }
                                              }`,
                                          {id:this.stillId});
      this.loading = false;
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.still = {...results.data.still, siteId:results.data.still.site.id, site:undefined};
    }
    else
      this.still.siteId = this.sites[0].id;
    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },

  methods: {
    async save() {
      this.saving = true;
      // eslint-disable-next-line no-unused-vars
      const {pictureURL,...input} = this.still;
      const results = await this.$apiCall(`mutation EquipmentStillsEdit($input: StillInput!) {
                                             stillCreate(input:$input) {id}
                                           }`,
                                          {input})

      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.still.id?'Updated':'Created'} still ${this.still.name}`});
      }
    }
  }
}
</script>